<template>
  <div class="l-notice-contanier">
    <div v-if="!messageList.length" class="notice-empty">
      <img src="../images/notice/empty.png" class="empty-img">
      暂无消息
    </div>
    <section v-else class="l-notice-ul-section">
      <ul class="notice-list">
        <li v-for="(item, index) in messageList" :key="item + index" class="notice-item">
          <img src="../images/notice/userLockIcon.png" class="notice-item-icon" />
          <article class="notice-item-value">
            <p class="notice-item-value-title">
              <span class="notice-item-name">{{ item.content.title }}</span>
              <span class="notice-item-time">{{ formatDate(parseInt(item.content.time)) }}</span>
            </p>
            <p class="notice-item-value-text">{{ item.content.content }}</p>
          </article>
          <article class="notice-item-r">
            <input type="checkbox" v-show="isDelete" v-model="Delids" :value="item.id" class="notice-radio" />
          </article>
        </li>
        <p @click="getMoreNoticeList()" class="more-notice-btn" v-show="pullRefreshss">点击加载更多</p>
      </ul>
      <p class="alldel-p">
        <span class="cancle-del" v-if="isDelete" @click="onShowCheckoout(0)">取消</span>
        <span class="confirm-del" v-if="isDelete" @click="onDelete()">删除</span>
        <span class="all-del" v-show="!isDelete && messageList.length > 0" @click="onShowCheckoout(1)">
          <img src="../images/notice/userDelIcon.png" /> 批量删除
        </span>
      </p>
    </section>
  </div>
</template>
<script>
import NotifyModel from "@/models/notify"
const notify = new NotifyModel()

export default {
  data() {
    return {
      messageList: [],
      isDelete: false,
      Delids: [],
      page: 1, //代表页面的初始页数
      pullRefreshss: false, // 代表可以进行下拉加载，false代表不能
    }
  },
  methods: {
    //获取消息列表
    getMessage(currentPage) {
      notify
        .getMessageList({
          page: currentPage,
          size: 20,
          status: 0, //readAllSuccess代表是否执行了已读接口，status为空，代表全部已读，无默认值，传1，可改为任何值
        })
        .then((res) => {
          this.$emit('noticeRedDot', res.data.unread)
          let list = res.data.messages || []
          list.forEach((item) => {
            item.checked = false
          })
          if (currentPage == 1) {
            this.messageList = list
          } else {
            this.messageList = this.messageList.concat(list)
          }
          if (list.length == 20) {
            this.pullRefreshss = true
          } else {
            this.pullRefreshss = false
          }
        })
    },
    //点击加载更多
    getMoreNoticeList() {
      //现在的操作 只要点击菜单就代表所有消息完全已读，此时点击查看更多查询的微所有已读消息，所以第二个参数为1，代表为null
      this.page++
      this.getMessage(this.page, 1)
    },
    // 批量删除操作
    onShowCheckoout(type) {
      this.isDelete = type ? true : false
      if (type == 0) {
        this.Delids = []
      }
    },
    //确认删除操作
    onDelete() {
      // console.log(this.Delids);
      if (this.Delids.length == 0) {
        return
      }
      notify
        .onDeleteMessage({
          ids: this.Delids,
        })
        .then(() => {
          this.isDelete = false
          this.page = 1
          this.getMessage(1, 1)
        })
    },

    getYMDHMS(timestamp) {
      let time = new Date(timestamp)
      let year = time.getFullYear()
      const month = (time.getMonth() + 1).toString().padStart(2, '0')
      const date = time.getDate().toString().padStart(2, '0')
      const hours = time.getHours().toString().padStart(2, '0')
      const minute = time.getMinutes().toString().padStart(2, '0')
      const second = time.getSeconds().toString().padStart(2, '0')
      return (
        year +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hours +
        ':' +
        minute +
        ':' +
        second
      )
    },
    formatDate(value) {
      let date = new Date(value)
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let DD = date.getDate()
      DD = DD < 10 ? '0' + DD : DD
      let dd = date.getHours()
      dd = dd < 10 ? '0' + dd : dd
      let mm = date.getMinutes()
      mm = mm < 10 ? '0' + mm : mm
      return `${MM}月${DD}日 ${dd}:${mm}`
    },
  },
  mounted() {
    this.getMessage(1)
  },
}
</script>
<style scoped>
.notice-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 120px;
  font-size: 32px;
  color: #fff;
}
.empty-img {
  width: 160px;
  height: 130px;
  margin-top: 160px;
  margin-bottom: 20px;
}

.notice-list {
  padding: 0;
  margin: 0;
  list-style: none;
}
.notice-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 128px;
  background: #fff3d3;
  border-radius: 23px;
  box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset;
}
.notice-item-icon {
  width: 80px;
  height: 80px;
  margin-left: 20px;
}
.notice-item-value {
  flex: 1;
}
.notice-item-value-title {
  display: flex;
  padding: 0;
  margin: 0;
  margin-right: 20px;

}
.notice-item-name {
  font-size: 28px;
  font-weight: bold;
  color: #6F6C68;
}
.notice-item-time {
  font-size: 20px;
  font-weight: bold;
  color: #8C9F63;
}
.notice-item-value-text {
  font-size: 24px;
  color: #6F6C68;
  padding: 0;
  margin: 0;
  margin-top: 10px;
}
.notice-item-r {
  margin-right: 20px;
}
.notice-radio {
  width: 20px;
  height: 20px;
}
</style>